import React, { Component } from "react";
import "./App.css";
import Home from "./Home";
import Home2 from "./Home2";
import { BrowserRouter as Router, Route } from "react-router-dom";

class App extends Component {
	render() {
		return (
			<Router basename={"/2s5n3amU"}>
				<div>
					<p>hola</p>
				</div>
			</Router>
		);
	}
}

export default App;